/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxMlYxMS4yMjEySDEyVjEySDJaTTQuMzM4MjcgOS42OTc5NFY4LjkxOTE3SDkuNjYxNzNWOS42OTc5NEg0LjMzODI3Wk0yIDcuMzg3NzZWNi42MDg5OUgxMlY3LjM4Nzc2SDJaTTQuMzM4MjcgNS4wODU3VjQuMzA2OTNIOS42NjE3M1Y1LjA4NTdINC4zMzgyN1pNMiAyLjc3ODc3VjJIMTJWMi43Nzg3N0gyWiIgZmlsbD0iYmxhY2siLz48L3N2Zz4=";